import React, { useEffect, useState } from 'react';
import {
  Box,
  Flex,
  Text,
  IconButton,
  FormControl,
  FormLabel,
  Input,
  Button,
  SimpleGrid,
  useDisclosure,
  VStack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Spinner,
  Center,
  Heading,
  Select,
} from '@chakra-ui/react';
import { FiMenu } from 'react-icons/fi';
import AdminSidebar from './AdminSidebar';
import { apiUrl } from '../ApiUrl/ApiUrl';
import { FiEdit, FiTrash2 } from 'react-icons/fi';

function AdminStaffManagment() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [imageFile, setImageFile] = useState(null);
  const [categoriess, setCategoriess] = useState([]);
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [editingBook, setEditingBook] = useState(null);
  // const booksPerPage = 5;
  const [booksPerPage, setBooksPerPage] = useState(5); // Default rows per page

  const [category, setCategory] = useState("");
 
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!category) {
      alert( " Select Activate or Deactivate User");
      return;
    }


    const formData = new FormData(e.target);
    console.log("Form Data Entries:", Object.fromEntries(formData.entries())); // Debugging
  
    const requestData = {
      id: formData.get("id") || null,
      name: formData.get("name"),
      username: formData.get("username"),
      password: formData.get("password"),
      role: formData.get("role"),
    };
  
    console.log("Submitting data:", requestData); // Debugging
  
 const token = localStorage.getItem("token")
  
    try {
      const response = await fetch(`${apiUrl}/admin/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" ,
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(requestData),
      });
  
      if (response.ok) {
        alert("Successfull!");
        AllBooks();
        e.target.reset();
      } else {
        const errorData = await response.json();
        alert(`Error: ${errorData.message}`);
      }
    } catch (error) {
      console.error("Error adding product:", error);
      alert("You Are Not Authorized");
    }
  };
  
  
  const AllBooks = () => {
    fetch(`${apiUrl}/public/getallusersbyrole`)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      setBooks(data.reverse());
      setLoading(false);
    })
    .catch(error => {
      console.error('Error fetching books:', error);
      setLoading(false);
    });
  }

  useEffect(() => {
    AllBooks();
  }, []);
  const handleEdit = (book) => {
    setEditingBook(book); // Set the entire book object for editing
  };
 
  
  // Pagination logic
  const indexOfLastBook = currentPage * booksPerPage;
  const indexOfFirstBook = indexOfLastBook - booksPerPage;
  const currentBooks = books.slice(indexOfFirstBook, indexOfLastBook);

  const totalPages = Math.ceil(books.length / booksPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };
 


  const handleMainCategoryChange = (event) => {
    const selectedCategory = event.target.value;
    setCategory(selectedCategory);

  };

 

  useEffect(() => {
    // When editingBook changes, set the initial category value
    if (editingBook) {
      setCategory(editingBook.category);  // Set category based on editingBook
    }
  }, [editingBook]);
  






  return (
<>



    <Flex h="100%" bg="gray.100">
      <AdminSidebar />
      <Box flex="1" p={4}>
        <Flex justify="space-between" align="center" bg="white" p={4} mb={4} borderRadius="md" shadow="sm">
          <IconButton icon={<FiMenu />} aria-label="Open menu" display={{ base: 'block', md: 'none' }} onClick={onOpen} />
          <Text fontSize="xl" fontWeight="bold">
            Staff Management
          </Text>
        </Flex>

        <Box bg="white" p={6} borderRadius="md" shadow="sm">
          <Text fontSize="lg" fontWeight="bold" mb={4}>
            Add New Product
          </Text>
          
          <form onSubmit={handleFormSubmit}>
            <SimpleGrid columns={4} spacing={4}>
                <Input type="hidden" placeholder="Enter Staff id" name="id" defaultValue={editingBook ? editingBook.id : ''}/>
              <FormControl id="name" isRequired>
                <FormLabel>Staff Name</FormLabel>
                <Input type="text" placeholder="Enter Staff Name" name="name" defaultValue={editingBook ? editingBook.name : ''}/>
              </FormControl>
            
              <FormControl id="username" isRequired>
                <FormLabel>Mobile Number</FormLabel>
                <Input type="text" placeholder="Enter Mobile Number" name="username" defaultValue={editingBook ? editingBook.username : ''}/>
              </FormControl>
             
              <FormControl id="password" isRequired>
                <FormLabel>Password</FormLabel>
                <Input type="text" placeholder="Enter password" name="password"/>
              </FormControl>
            
 
    
       
             
             
              <FormControl id="role" isRequired>
        <FormLabel>Activate/Deactivate Staff</FormLabel>
        <select name="role" value={category} onChange={handleMainCategoryChange}>
          <option selected>Select Category</option>
          <option value="ADMIN">ADMIN</option>
          <option value="staff">Activate</option>
          <option value="deactivatestaff">Deactivate</option>
        
        </select>
      </FormControl>

  
            

    

    {/* Select Color */}
   

    {/* Select Material */}
   

            </SimpleGrid>
            <VStack mt={4} align="stretch">
              <Button type="submit" colorScheme="teal" width="full" >
                Save
              </Button>
            </VStack>
          </form>
        </Box>

        <Box p={3}>
      <Heading as="h2" size="lg" mb={4}>Staff List</Heading>
      {loading ? (
        <Center>
          <Spinner size="sm" />
        </Center>
      ) : (
        <>
          <TableContainer>
          <Flex justify="space-between" mb={4}>

          <Select
          width="150px"
          value={booksPerPage}
          onChange={(e) => {
            setBooksPerPage(Number(e.target.value));
            setCurrentPage(1); // Reset to first page on change
          }}
        >
          <option value="5">5 per page</option>
          <option value="10">10 per page</option>
          <option value="20">20 per page</option>
          <option value="50">50 per page</option>
        </Select>
        <h1>Total Staff : {currentBooks.length}</h1>


        {/* <Flex gap={2}>
          <Button onClick={prevPage} isDisabled={currentPage === 1}>
            Previous
          </Button>
          <Button onClick={nextPage} isDisabled={currentPage === totalPages}>
            Next
          </Button>
        </Flex> */}
      </Flex>
            <Table variant="striped" colorScheme="teal">
              <Thead>
                <Tr>
                  <Th>ID</Th>
                  <Th>Name</Th>
                  <Th>Mobile Number</Th>
                  <Th>Role</Th>
            
            
                
                 
                  <Th>Actions</Th>
                </Tr>
              </Thead>
              <Tbody>
                {currentBooks.map(book => (
                  <Tr key={book.id}>
                    <Td>{book.id}</Td>
                    <Td>{book.name}</Td>
             
                    <Td>{book.username}</Td>
                    <Td>{book.role}</Td>
              
                  
                   
                   
                    <Td>
                      <Flex gap={2}>
                        <IconButton
                          aria-label="Edit Book"
                          icon={<FiEdit />}
                          // onClick={() => handleEdit(book)}
                          onClick={() => {
                            handleEdit(book);
                            window.scrollTo({ top: 0, behavior: "smooth" });
                          }}
                        />
                      
                      </Flex>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
          <Flex justify="space-between" mt={4}>
            <Button onClick={handlePreviousPage} disabled={currentPage === 1}>
              Previous
            </Button>
            <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
              Next
            </Button>
          </Flex>
        </>
      )}
    </Box>
      </Box>

    </Flex>

 
</>
    
  );
}

export default AdminStaffManagment;
